import { __ } from '@wordpress/i18n';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

const Save = ({ attributes }) => {

    const blockProps = useBlockProps.save({
        className: 'vayu-hots-wrapper'
    });
    const innerBlocksProps = useInnerBlocksProps.save( blockProps );
 
    return <div {...innerBlocksProps} />
};

export default Save;
